import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Delete Org Logo Request Schema
 * DELETE /api/v2/org-logo
 * Deletes the organization's logo
 */ export const DeleteOrgLogoRequestSchema = z.object({});
/**
 * Delete Org Logo Response Schema
 */ export const DeleteOrgLogoResponseSchema = z.object({
    success: z.boolean()
});
/**
 * Delete Org Logo Error Schema
 */ export const DeleteOrgLogoErrorSchema = BaseErrorSchema;

//# sourceMappingURL=delete-org-logo.schema.js.map